import { render, staticRenderFns } from "./AspectTableSortingSingle.vue?vue&type=template&id=1e04532c&scoped=true&"
import script from "./AspectTableSortingSingle.vue?vue&type=script&lang=js&"
export * from "./AspectTableSortingSingle.vue?vue&type=script&lang=js&"
import style0 from "./AspectTableSortingSingle.vue?vue&type=style&index=0&id=1e04532c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e04532c",
  null
  
)

export default component.exports